import { HttpClient, HttpParams } from '@angular/common/http';
import * as i0 from '@angular/core';
import { inject, Injectable } from '@angular/core';
import { WEB_DATA_SERVICES_CONFIG, AvcCoreDataBaseUrl } from '@garmin-avcloud/avcloud-web-data-services/config';
let AircraftReadService = /*#__PURE__*/(() => {
  class AircraftReadService {
    constructor() {
      this.http = inject(HttpClient);
      this.config = inject(WEB_DATA_SERVICES_CONFIG);
      this.baseUrl = `${AvcCoreDataBaseUrl[this.config.environment]}/aircraftManagementReadService/aircraft`;
    }
    getAircraftByAircraftUuid(aircraftUuid, includeMasterAircraftUuid = false) {
      const params = new HttpParams().append('includeMasterAircraftUuid', includeMasterAircraftUuid);
      return this.http.get(`${this.baseUrl}/${aircraftUuid}`, {
        params
      });
    }
    getAircraft(customerGuid, includeMasterAircraftUuid = false, includeDeleted = false) {
      let params;
      if (customerGuid != null) {
        params = new HttpParams({
          fromObject: {
            customerGuid,
            includeMasterAircraftUuid,
            includeDeleted
          }
        });
      } else {
        params = new HttpParams({
          fromObject: {
            includeMasterAircraftUuid,
            includeDeleted
          }
        });
      }
      return this.http.get(this.baseUrl, {
        params
      });
    }
    static {
      this.ɵfac = function AircraftReadService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AircraftReadService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AircraftReadService,
        factory: AircraftReadService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AircraftReadService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AircraftValidationReadService = /*#__PURE__*/(() => {
  class AircraftValidationReadService {
    constructor() {
      this.http = inject(HttpClient);
      this.config = inject(WEB_DATA_SERVICES_CONFIG);
      this.baseUrl = `${AvcCoreDataBaseUrl[this.config.environment]}/aircraftManagementReadService/aircraft-validation`;
    }
    validateTailNumber(tailNumber) {
      const requestBody = {
        tailNumber: tailNumber
      };
      return this.http.post(`${this.baseUrl}/tail-number`, requestBody);
    }
    validateSystem(systemId, systemTypeId) {
      const requestBody = {
        systemId: systemId,
        systemTypeId: systemTypeId
      };
      return this.http.post(`${this.baseUrl}/system-id`, requestBody);
    }
    getAircraftValidationTailNumberRegex(tailNumber) {
      const requestBody = {
        tailNumber: tailNumber
      };
      return this.http.post(`${this.baseUrl}/tail-number/regex`, requestBody);
    }
    static {
      this.ɵfac = function AircraftValidationReadService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AircraftValidationReadService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AircraftValidationReadService,
        factory: AircraftValidationReadService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AircraftValidationReadService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ConnectedCockpitRegistrationReadService = /*#__PURE__*/(() => {
  class ConnectedCockpitRegistrationReadService {
    constructor() {
      this.http = inject(HttpClient);
      this.config = inject(WEB_DATA_SERVICES_CONFIG);
      this.baseUrl = `${AvcCoreDataBaseUrl[this.config.environment]}/aircraftManagementReadService/connected-cockpit-registrations`;
    }
    getConnectedCockpitRegistration(masterAircraftUuid, code) {
      let params = new HttpParams();
      if (masterAircraftUuid != null) {
        params = params.append('masterAircraftUuid', masterAircraftUuid);
      }
      if (code != null) {
        params = params.append('code', code);
      }
      return this.http.get(this.baseUrl, {
        params
      });
    }
    static {
      this.ɵfac = function ConnectedCockpitRegistrationReadService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConnectedCockpitRegistrationReadService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ConnectedCockpitRegistrationReadService,
        factory: ConnectedCockpitRegistrationReadService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ConnectedCockpitRegistrationReadService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FixedDeviceTypeReadService = /*#__PURE__*/(() => {
  class FixedDeviceTypeReadService {
    constructor() {
      this.http = inject(HttpClient);
      this.config = inject(WEB_DATA_SERVICES_CONFIG);
      this.baseUrl = `${AvcCoreDataBaseUrl[this.config.environment]}/deviceReadService/fixed-device-types`;
    }
    getAllFixedDeviceTypes(includeDeleted = false) {
      const params = new HttpParams().append('includeDeleted', includeDeleted);
      return this.http.get(`${this.baseUrl}`, {
        params
      });
    }
    getFixedDeviceTypesBySerialNumber(serialNumber) {
      return this.http.get(`${this.baseUrl}/by-serial-number/${serialNumber}`);
    }
    static {
      this.ɵfac = function FixedDeviceTypeReadService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FixedDeviceTypeReadService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FixedDeviceTypeReadService,
        factory: FixedDeviceTypeReadService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FixedDeviceTypeReadService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SystemTypeReadService = /*#__PURE__*/(() => {
  class SystemTypeReadService {
    constructor() {
      this.http = inject(HttpClient);
      this.config = inject(WEB_DATA_SERVICES_CONFIG);
      this.baseUrl = `${AvcCoreDataBaseUrl[this.config.environment]}/deviceReadService/system-types`;
    }
    getAllSystemTypes(includeDeleted = false) {
      const params = new HttpParams().append('includeDeleted', includeDeleted);
      return this.http.get(`${this.baseUrl}`, {
        params
      });
    }
    getSystemType(id) {
      return this.http.get(`${this.baseUrl}/${id}`);
    }
    getSystemTypeSummary(id) {
      return this.http.get(`${this.baseUrl}/${id}/summarize`);
    }
    static {
      this.ɵfac = function SystemTypeReadService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SystemTypeReadService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SystemTypeReadService,
        factory: SystemTypeReadService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SystemTypeReadService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AircraftSystemWriteService = /*#__PURE__*/(() => {
  class AircraftSystemWriteService {
    constructor() {
      this.http = inject(HttpClient);
      this.config = inject(WEB_DATA_SERVICES_CONFIG);
      this.baseUrl = `${AvcCoreDataBaseUrl[this.config.environment]}/aircraftManagementWriteService/aircraft-systems`;
    }
    createAircraftSystemDevice(aircraftSystemSummary, includeMasterAircraftUuid = false) {
      const params = new HttpParams().set('includeMasterAircraftUuid', includeMasterAircraftUuid);
      return this.http.post(`${this.baseUrl}/with-devices`, aircraftSystemSummary, {
        params
      });
    }
    createAircraftSystemDeviceById(uuid, aircraftSystemDevice) {
      return this.http.post(`${this.baseUrl}/aircraft-systems/${uuid}/devices`, aircraftSystemDevice);
    }
    updateAircraftSystemDevice(systemUuid, deviceUuid, device) {
      return this.http.put(`${this.baseUrl}/${systemUuid}/devices/${deviceUuid}`, device);
    }
    static {
      this.ɵfac = function AircraftSystemWriteService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AircraftSystemWriteService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AircraftSystemWriteService,
        factory: AircraftSystemWriteService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AircraftSystemWriteService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ConnectedCockpitRegistrationWriteService = /*#__PURE__*/(() => {
  class ConnectedCockpitRegistrationWriteService {
    constructor() {
      this.http = inject(HttpClient);
      this.config = inject(WEB_DATA_SERVICES_CONFIG);
      this.baseUrl = `${AvcCoreDataBaseUrl[this.config.environment]}/aircraftManagementWriteService/connected-cockpit-registrations`;
    }
    deleteConnectedCockpitRegistrationUnredeemed(uuid) {
      return this.http.delete(`${this.baseUrl}/${uuid}/unredeemed`);
    }
    refresh(masterAircraftUuid) {
      const params = new HttpParams().append('masterAircraftUuid', masterAircraftUuid);
      return this.http.put(`${this.baseUrl}/refresh`, null, {
        params
      });
    }
    static {
      this.ɵfac = function ConnectedCockpitRegistrationWriteService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConnectedCockpitRegistrationWriteService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ConnectedCockpitRegistrationWriteService,
        factory: ConnectedCockpitRegistrationWriteService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ConnectedCockpitRegistrationWriteService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AircraftReadService, AircraftSystemWriteService, AircraftValidationReadService, ConnectedCockpitRegistrationReadService, ConnectedCockpitRegistrationWriteService, FixedDeviceTypeReadService, SystemTypeReadService };
